import React, { useEffect, useRef, useState } from "react";
import classes from "./Header.module.css";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Stack,
  Divider,
  IconButton,
  Drawer,
  Menu,
  MenuItem,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Close, MenuOpen } from "@mui/icons-material";
import { Link } from "react-scroll";
import DropDownButton from "../HomeButtons/DropDownButton";
import { useNavigate } from "react-router-dom";
import SignupModal from "../SignupModal/SignupModal";
import Logo from "../../../assets/images/svg/Logo.svg";
import { API_ENDPOINT } from "../../../services/api/resources";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const NavLinks = ({ sectionLinks = [] }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const desktop = window.matchMedia("(min-width: 1561px)");
    const closeOnDesktop = () => {
      if (desktop.matches) setOpen(false);
    };
    desktop.addEventListener("change", closeOnDesktop);
    return () => desktop.removeEventListener("change", closeOnDesktop);
  }, []);

  const [selectedRole, setSelectedRole] = useState("");

  const [demomodal, setDemoModal] = useState(false);
  const [step, setStep] = useState(1); // 1: Email, 2: OTP, 3: Success
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [isLoading, setIsLoading] = useState(false);

  const otpRefs = [useRef(), useRef(), useRef(), useRef()];
  const [selectedDemo, setSelectedDemo] = useState(null); // "signup" or "merchant"

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleSelect = (demoType) => {
    setOpen(false);
    setSelectedDemo(demoType);
    setStep(1);
    setDemoModal(true);
    handleClose();
  };

  const handleRoleChange = (role) => {
    setSelectedRole(role);
  };
  const [openSignupOptions, setOpenSignupOptions] = useState(false);
  const handleCloseSignupOptions = () => {
    setOpenSignupOptions(false);
    setSelectedRole("");
  };
  const navigate = useNavigate();

  const signupOptions = [
    {
      path: "buyer_organization_signup",
      path_name: "Buyer Organization Signup",
    },
    {
      path: "vendor_signup",
      path_name: "Vendor Signup",
    },
  ];

  const redirectVendorPage = () => {
    setStep(1);
    setEmail("");
    setDemoModal(false);

    if (selectedDemo === "signup") {
      navigate("/poc_vendor_signup");
    } else if (selectedDemo === "invoice") {
      navigate("/poc_Invoice_Automation");
    }
  };

  const sendOTP = async () => {
    setIsLoading(true);
    try {
      const res = await axios.post(API_ENDPOINT.send_otp_to_email, { email });
      console.log(res.data.message);
      setStep(2);
    } catch (err) {
      console.error(err.response?.data?.error || "Failed to send OTP");
    } finally {
      setIsLoading(false);
    }
  };

  const verifyOTP = async () => {
    // if (otp.join("") === "1234") setStep(3);
    const enteredOTP = otp.join("");

    if (enteredOTP.length < 4) {
      alert("Please enter a 4-digit OTP");
      return;
    }

    try {
      const response = await axios.post(API_ENDPOINT.verify_otp, {
        email: email,
        otp: enteredOTP,
      });

      if (response.data.message === "OTP verified") {
        setStep(3);
      } else {
        alert("OTP verification failed");
      }
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.error || "OTP verification failed");
    }
  };

  const handleOtpChange = (index, value) => {
    const updated = [...otp];
    updated[index] = value.slice(-1); // only take last digit
    setOtp(updated);

    if (value && index < otp.length - 1) {
      otpRefs[index + 1].current.focus(); // move to next box
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      otpRefs[index - 1].current.focus();
    }
  };


  return (
    <>
      {/* Navigation */}
      <div className={`${classes.links} ${classes.flex}`}>
        <div className={classes.lgBtn}>
          <DropDownButton
            label={"RFI Signup"}
            noOptions={true}
            mainClick={() => navigate("/rfi_signup")}
          />
          <DropDownButton
            label={"Signup"}
            noOptions={true}
            mainClick={() => {
              setOpenSignupOptions(true);
            }}
          />
          <DropDownButton
            label={"Login"}
            noOptions={true}
            mainClick={() => navigate("/login")}
          />
        </div>
        <SignupModal
          openSignupOptions={openSignupOptions}
          selectedRole={selectedRole}
          handleCloseSignupOptions={handleCloseSignupOptions}
          setOpenSignupOptions={setOpenSignupOptions}
          handleRoleChange={handleRoleChange}
        />

        <Button onClick={handleClick} endIcon={<ArrowDropDownIcon />} sx={{ fontFamily: "Source Sans Regular", fontSize: "1.6rem" }} >
          POC
        </Button>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem onClick={() => { handleSelect("signup") }} sx={{ fontSize: "1.4rem" }}>
            Supplier Onboarding Automation
          </MenuItem>
          <MenuItem onClick={() => { handleSelect("invoice") }} sx={{ fontSize: "1.4rem" }}>
            Trade Claims Automation
          </MenuItem>
        </Menu>
      </div>

      <button
        type="button"
        onClick={() => setOpen(true)}
        className={classes.menuOpener}
        aria-label="Open navigation menu"
        aria-expanded={open}
        aria-controls={open ? "home-navigation-drawer" : undefined}
      >
        <MenuOpen className={classes.menuOpenerIcon} />{" "}
      </button>

      <Drawer
        open={open}
        anchor={"right"}
        onClose={() => setOpen(false)}
        className={classes.menuDraw}
        PaperProps={{ className: classes.drawerPaper }}
      >
        <div id="home-navigation-drawer" className={classes.menuTab}>
          <div className={classes.drawerBrand}>
            <img src={Logo} alt="bidZ.ai" />
            <span>Intelligent procurement. Connected.</span>
          </div>
          {/* CLOSE BUTTON */}
          <IconButton
            onClick={() => setOpen(false)}
            aria-label="Close navigation menu"
            sx={{ position: "absolute", top: 10, right: 10 }}
          >
            <Close />
          </IconButton>

          <p className={classes.drawerLabel}>EXPLORE BIDZ.AI</p>
          <nav className={classes.mobileSectionNav} aria-label="Mobile page navigation">
            {sectionLinks.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                smooth="easeOutCubic"
                duration={220}
                offset={-96}
                spy
                onClick={() => setOpen(false)}
                activeClass={classes.activeMobileSectionChip}
                className={`${classes.mobileSectionChip} ${item.to === "pricing" ? classes.pricingChip : ""}`}
                href={`#${item.to}`}
              >
                {item.label}
                {item.to === "pricing" && <span className={classes.pricingBadge}>₹ 999+</span>}
              </Link>
            ))}
          </nav>

          <p className={classes.drawerLabel}>GET STARTED</p>
          <div className={`${classes.lgBtn} ${classes.mobileActionList}`}>
            <DropDownButton
              label={"RFI Signup"}
              noOptions={true}
              mainClick={() => {
                setOpen(false);
                navigate("/rfi_signup");
              }}
            />
            <DropDownButton
              label={"Signup"}
              noOptions={true}
              mainClick={() => {
                setOpen(false);
                setOpenSignupOptions(true);
              }}
            />

            <DropDownButton
              label={"Login"}
              noOptions={true}
              mainClick={() => {
                setOpen(false);
                navigate("/login");
              }}
            />
            <Button
              onClick={handleClick}
              endIcon={<ArrowDropDownIcon />}
              className={classes.mobilePocButton}
              sx={{ fontSize: "1.5rem" }}
            >
              POC
            </Button>
          </div>

        </div>
      </Drawer>

      {/* MODAL */}
      {/* MODAL */}
      <Modal open={demomodal} onClose={() => setDemoModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "92%", sm: 520 },
            maxWidth: 520,
            bgcolor: "#ffffff",
            borderRadius: "20px",
            boxShadow: "0px 30px 80px rgba(0,0,0,0.12)",
            p: 5,
            fontFamily: "Inter, sans-serif",
          }}
        >
          {/* Close Button */}
          <IconButton
            onClick={() => setDemoModal(false)}
            sx={{
              position: "absolute",
              top: 16,
              right: 16,
              bgcolor: "#F3F4F6",
              "&:hover": { bgcolor: "#E5E7EB" },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>

          {/* Header */}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ mb: 3 }}
          >
            <Box>
              <Typography
                sx={{
                  fontSize: "22px",
                  fontWeight: 700,
                  letterSpacing: "-0.3px",
                }}
              >
                Explore POC
              </Typography>

              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#6B7280",
                  mt: 0.5,
                }}
              >
                Real flow. Real data. Zero fluff.
              </Typography>
            </Box>

            <Box component="img" src={Logo} sx={{ width: 100, marginRight: "7px" }} />
          </Stack>

          <Divider sx={{ mb: 1 }} />

          {/* STEP 1 */}
          {step === 1 && (
            <Box>
              <Typography
                sx={{
                  fontSize: "18px",
                  fontWeight: 600,
                  mt: 0,   // small top margin (8px)
                  mb: 2,
                }}
              >
                Enter Your Business Email
              </Typography>
              <TextField
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="poc@company.com"
                sx={{
                  mb: 3,

                  "& .MuiOutlinedInput-root": {
                    borderRadius: "14px",
                    height: "58px", // increase input height
                    fontSize: "16px", // input text size
                  },

                  "& .MuiInputBase-input::placeholder": {
                    fontSize: "16px", // placeholder size
                    opacity: 0.3,
                  },
                }}
              />

              <Button
                fullWidth
                variant="contained"
                disabled={!email || isLoading}
                onClick={sendOTP}
                sx={{
                  height: "50px",
                  borderRadius: "14px",
                  fontWeight: 600,
                  fontSize: "15px",
                  textTransform: "none",
                  boxShadow: "0px 8px 20px rgba(0,0,0,0.08)",
                }}
              >
                {isLoading ? "Sending OTP..." : "Continue"}
              </Button>
            </Box>
          )}

          {/* STEP 2 */}
          {step === 2 && (
            <Box textAlign="center">
              <Typography
                sx={{
                  fontSize: "18px",
                  fontWeight: 600,
                  mb: 1,
                }}
              >
                Enter OTP
              </Typography>

              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#6B7280",
                  mb: 3,
                }}
              >
                Sent to <b>{email}</b>
              </Typography>

              <Box display="flex" justifyContent="center" gap={2} mb={3}>
                {otp.map((digit, i) => (
                  <TextField
                    key={i}
                    inputRef={otpRefs[i]}
                    value={digit}
                    onChange={(e) => handleOtpChange(i, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(e, i)}
                    inputProps={{
                      maxLength: 1,
                      style: {
                        textAlign: "center",
                        fontSize: "20px",
                        fontWeight: 600,
                      },
                    }}
                    sx={{
                      width: 64,
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "14px",
                        height: "56px",
                      },
                    }}
                  />
                ))}
              </Box>

              <Button
                fullWidth
                variant="contained"
                onClick={verifyOTP}
                sx={{
                  height: "50px",
                  borderRadius: "14px",
                  fontWeight: 600,
                  fontSize: "15px",
                  textTransform: "none",
                  boxShadow: "0px 8px 20px rgba(0,0,0,0.08)",
                }}
              >
                Verify
              </Button>
            </Box>
          )}

          {/* STEP 3 */}
          {step === 3 && (
            <Box textAlign="center">
              <CheckCircleOutlineIcon
                sx={{
                  fontSize: 70,
                  color: "success.main",
                  mb: 2,
                }}
              />

              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: 700,
                  mb: 1,
                }}
              >
                Verification Successful
              </Typography>

              <Typography
                sx={{
                  fontSize: "14px",
                  color: "#6B7280",
                  mb: 4,
                }}
              >
                You can now explore the POC experience.
              </Typography>

              <Button
                fullWidth
                variant="contained"
                onClick={redirectVendorPage}
                sx={{
                  height: "50px",
                  borderRadius: "14px",
                  fontWeight: 600,
                  fontSize: "15px",
                  textTransform: "none",
                  boxShadow: "0px 8px 20px rgba(0,0,0,0.08)",
                }}
              >
                Continue
              </Button>
            </Box>
          )}
        </Box>
      </Modal>
      {openSignupOptions && (
        <SignupModal
          open={openSignupOptions}
          handleClose={handleCloseSignupOptions}
          signupOptions={signupOptions}
        />
      )}
    </>
  );
};

export default NavLinks;
